var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.layout,{tag:"component"},[_c('router-view'),_c('SignInDialogue',{ref:"signInDialogue",on:{"is-authenticated":_vm.onAuthenticated}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }